import moment from "moment";
import _ from "lodash";
import { getLocalPhoneNumber, getPdfMargins } from "../../util/helpers";

export const getSalaryAutoTableData = (data, columns) => {
  return {
    columns: columns.map((i) => ({
      header: i.label,
      dataKey: i.key,
    })),
    body: data,

    headStyles: {
      fillColor: "#464646",
    },
    alternateRowStyles: {
      fillColor: "#FAFAFA",
    },
  };
};

export const setSalaryHeader = (doc, headerRecord) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  var title = "טבלת שכר";
  const report = "תאריך הדפסה";
  const date = `${moment().format("HH:mm DD/MM/YYYY")}`;
  const reportDate = `${report} - ${date}`;
  const margins = getPdfMargins(doc);
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  doc.text(title, hLoc, 20, {
    align: "right",
  });
  doc.setFontSize(10);
  doc.text(reportDate, margins, 20, {
    align: "left",
  });
};
